import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var LocationInfo = function LocationInfo() {
    _classCallCheck(this, LocationInfo);

    this.latitude = '';
    this.longitude = '';
    this.country = '';
    this.province = '';
    this.city = '';
    this.district = '';
    this.citycode = '';
    this.adcode = '';
    this.street = '';
    this.number = '';
    this.POIName = '';
    this.AOIName = '';
};